<template>
  <div id="app">
    <Waiting-For-Server></Waiting-For-Server>
    <Global-Message></Global-Message>
    <router-view></router-view>
    <Footer-Block></Footer-Block>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import FooterBlock from './components/FooterBlock/FooterBlock';
  import GlobalMessage from './components/GlobalMessage';
  import WaitingForServer from './components/WaitingForServer';
  import locales from './translations';

  const $ = window.$;

  export default {
    name: 'App',
    locales,
    components: {
      'Footer-Block': FooterBlock,
      'Global-Message': GlobalMessage,
      'Waiting-For-Server': WaitingForServer,
    },
    methods: {
      ...mapActions({
        getGroups: 'getGroups',
      }),
    },
    created() {
      this.$store.dispatch('getCategories');
      this.$store.dispatch('getLocations');
      this.getGroups();
      function sizeClass() { // currenty only used to show breakpoints
        $('body').addClass('screenXs');
        $('body').removeClass('screenSm');
        $('body').removeClass('screenMd');
        $('body').removeClass('screenLg');
        $('body').removeClass('screenXl');

        if ($(window).width() > 544) {
          $('body').removeClass('screenXs');
          $('body').addClass('screenSm');
          $('body').removeClass('screenMd');
          $('body').removeClass('screenLg');
          $('body').removeClass('screenXl');
        }

        if ($(window).width() > 768) {
          $('body').removeClass('screenXs');
          $('body').removeClass('screenSm');
          $('body').addClass('screenMd');
          $('body').removeClass('screenLg');
          $('body').removeClass('screenXl');
        }

        if ($(window).width() > 992) {
          $('body').removeClass('screenXs');
          $('body').removeClass('screenSm');
          $('body').removeClass('screenMd');
          $('body').addClass('screenLg');
          $('body').removeClass('screenXl');
        }

        if ($(window).width() > 1200) {
          $('body').removeClass('screenXs');
          $('body').removeClass('screenSm');
          $('body').removeClass('screenMd');
          $('body').removeClass('screenLg');
          $('body').addClass('screenXl');
        }
      }
      $(window).on('resize', () => {
        sizeClass();
      });
      sizeClass();
    },
  };
</script>

<style lang="scss">
  @import "./assets/scss/init.scss";
  @import "./assets/scss/forms.scss";
  #app {
    min-height: 100vh;
  }

</style>



// WEBPACK FOOTER //
// App.vue?c88c431c